import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SubPortfolioProjectsRoutingModule } from './sub-portfolio-projects-routing.module';
import { SubPortfolioProjectsComponent } from './sub-portfolio-projects.component';

import { DxDataGridModule } from 'devextreme-angular';
import { I18nModule } from "app/shared/i18n/i18n.module";
import { MaterialModule } from 'app/material.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { RouterModule } from '@angular/router';
import { CurrencyFormatterPipeModule } from 'app/shared/currency-formatter-pipe/currencyFormatterPipe.module';


@NgModule({
  declarations: [SubPortfolioProjectsComponent],
  imports: [
    CommonModule,
    DxDataGridModule,
    I18nModule,
    MaterialModule,
    FormsModule,
    NgxSpinnerModule,
    RouterModule,
    CurrencyFormatterPipeModule,
    SubPortfolioProjectsRoutingModule
  ]
})
export class SubPortfolioProjectsModule { }
